import React from 'react'
import type { AccountHolderDetails } from '@mobi/api-types'

type Address = AccountHolderDetails['postalAddress']

type AddressLabelProps = {
  address: Address
}

export const AddressLabel = ({ address }: AddressLabelProps) => {
  const addressLine = [
    address.unitNumber,
    address.streetNumber,
    address.streetName,
    address.streetType,
  ].join(' ')

  const cityLine = [address.suburb, address.state, address.postcode].join(' ')

  return (
    <>
      <div>{addressLine}</div>
      <div>{cityLine}</div>
      {address.country !== 'Australia' ? <div>{address.country}</div> : null}
    </>
  )
}
